module.exports = __webpack_public_path__ + "static/media/org-management.a73e4aa3.png";